module.exports = __webpack_public_path__ + "static/media/intro.1ebc1b87.mp3";